import type { FormData } from '../drawer-filter.type';
import { FiltersDateRange } from '../drawer-filter.type';

const transformFormDataToQuery = ({
  labels,
  tags,
  others,
  period,
  customDate,
  playbooks,
  playbookVersions,
  externalId,
}: FormData) => {
  const getPeriod = () => {
    if (period === FiltersDateRange.Custom) {
      const newFrom = customDate.from.toISOString();
      const newTo = customDate.to.toISOString();
      return {
        dateRangeStart: newFrom,
        dateRangeEnd: newTo,
      };
    }
    return {
      dateRangeStart: period,
      dateRangeEnd: undefined,
    };
  };

  const has = (key: string) => {
    if (!others) {
      return false;
    }
    return others.includes(key);
  };

  const playbookIds = Object.keys(playbooks).filter(key => playbooks[key]);
  const playbookVersion = Object.keys(playbookVersions).find(key => playbookVersions[key]);

  return {
    labels,
    tags,
    ...getPeriod(),
    watchlistHit: has('watchlistHit'),
    hasOutstandingWorkflowRequest: has('hasOutstandingWorkflowRequest'),
    showUnverified: has('showUnverified'),
    playbookIds,
    playbookVersion,
    externalId: externalId || undefined,
  };
};

export default transformFormDataToQuery;
